import { createPinia } from "pinia";
import { createApp } from "vue";

import { environment, isCloud, sentryDsn } from "@/environment";
import "@/styles/legacy.scss";
import { handleError } from "@/errorHandler";

import App from "./App.vue";
import { initializeGlobalVue, registerDirectives } from "./init";
import { createAppRouter } from "./router";
import { captureExceptionWithContext, initConsoleSentry, initRealSentry } from "./sentry";

const app = createApp(App);

initErrorHandlers(app);

const pinia = createPinia();
app.use(pinia);

initializeGlobalVue(app);
registerDirectives(app);

const router = createAppRouter(pinia);
app.use(router);

// Wait for router to be ready before mounting to prevent flash of incorrect content
router
  .isReady()
  .catch((err) => captureExceptionWithContext(err))
  .then(() => app.mount("#app"));

// Real Intercom will be initialized after login if enabled
// Dummy init here so we can call Intercom without checking availability
window.Intercom = () => {};

function initErrorHandlers(app) {
  window.onunhandledrejection = (event) => {
    event.preventDefault();
    handleError(event.reason);
  };
  window.onerror = (msg, url, line, col, error) => {
    void captureExceptionWithContext(error);
    return true;
  };
  window.addEventListener("vite:preloadError", (event) => {
    event.preventDefault();
    handleError(event.payload);
  });

  if (isCloud && sentryDsn) {
    initRealSentry({ app, dsn: sentryDsn, environment });
  } else {
    initConsoleSentry();
  }
}
